import { gql } from 'apollo-angular';

export const CAMPAIGN_MONITORING_MONITOR = gql`
  query ($id: ID!) {
    campaignMonitoring(id: $id) {
      id
      nodes {
        id
        customerCasesCount
        firstSchedule
        lastSchedule
      }
    }
  }
`;
